/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import {
  TRANSLOCO_LOADER,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
  provideTranslocoMissingHandler,
  provideTranslocoTranspiler,
  DefaultTranspiler,
  DefaultMissingHandler,
  provideTranslocoInterceptor, DefaultInterceptor, provideTranslocoFallbackStrategy, DefaultFallbackStrategy,
} from '@jsverse/transloco';
import { Injectable, NgModule, isDevMode } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string) {
    return import(`src/locale/messages.${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en', 'es', 'pt', 'de', 'fi', 'fr', 'sv', 'no', 'nl'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    provideTranslocoTranspiler(DefaultTranspiler),
    provideTranslocoMissingHandler(DefaultMissingHandler),
    provideTranslocoInterceptor(DefaultInterceptor),
    provideTranslocoFallbackStrategy(DefaultFallbackStrategy),
  ],
})
export class TranslocoRootModule {}
